<template>
  <div class="nav-wrapper" :class="{ ' nav-fixed-bottom': fixed }">
    <div v-if="Object.keys(rmdSizes).length" @click="$emit('changed', 'discover')">
      <img
        src="@/assets/DefaultCloudzet/HomePage/discover.svg"
        alt="measurement"
        :class="{ inactive: activePage !== 'discover' }"
      />
      <img
        v-if="activePage === 'discover'"
        class="mx-auto"
        src="@/assets/DefaultCloudzet/HomePage/circle.svg"
        alt="circle"
      />
    </div>
    <div @click="$emit('changed', 'measurement')">
      <img
        src="@/assets/DefaultCloudzet/HomePage/measurement.svg"
        alt="measurement"
        :class="{ inactive: activePage !== 'measurement' }"
      />
      <img
        v-if="activePage === 'measurement'"
        class="mx-auto"
        src="@/assets/DefaultCloudzet/HomePage/circle.svg"
        alt="circle"
      />
    </div>
    <div @click="$emit('changed', 'profile')">
      <img
        src="@/assets/DefaultCloudzet/HomePage/profile.svg"
        alt="profile"
        :class="{ inactive: activePage !== 'profile' }"
      />
      <img
        v-if="activePage === 'profile'"
        class="mx-auto"
        src="@/assets/DefaultCloudzet/HomePage/circle.svg"
        alt="circle"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    activePage: {
      type: String,
      default: 'measurement',
    },
    fixed: Boolean,
  },
  computed: {
    ...mapState('user', ['me']),
    ...mapGetters('user', ['rmdSizes']),
    hasRmdSizes() {
      return Object.keys(this.rmdSizes).length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.inactive {
  filter: grayscale(100%);
}

.nav-wrapper {
  @apply mb-10 mx-auto flex justify-between items-center px-16 w-5/6 rounded-full;
  @screen md {
    @apply px-32;
    max-width: 522px;
  }
  z-index: 1;
  max-width: 300px;
  min-height: 56px;
  background: #fafafa;
  border: 1px solid #ffffff;
  box-shadow: 0px 2px 12px rgba(67, 78, 108, 0.5);
  border-radius: 28px;
}

.nav-fixed-bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
